import { useQuery } from '@tanstack/react-query';
import { api } from './client.js';

/**
 * Which optional parts the platform has switched on (API server.ts /platform-features): WhatsApp and
 * Telegram conversations (docs/43) and Microsoft Teams calling (docs/44). A part that is off is not
 * shown at all, rather than offered and then refused.
 */
export interface PlatformFeatures { conversations: boolean; teams: boolean }

export const usePlatformFeatures = () =>
  useQuery({
    queryKey: ['platform-features'],
    queryFn: () => api.get<PlatformFeatures>('/v1/platform-features'),
    staleTime: 10 * 60_000,
  });
